import axios from 'axios';
import { setUrlPathFromDomainForV25 } from './utils/domain';

export const _post = async <T = unknown>(body: unknown): Promise<T> => {
  const response = await axios.post<T>('', body, {
    headers: {
      'Content-Type': 'application/json',
    },
  });
  return response.data;
};

export const _postFormData = async <T = unknown>(
  body: FormData | Record<string, unknown>
): Promise<T> => {
  const response = await axios.post<T>('', body, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

export const _postAllHeaders = async <T = unknown>(
  payload: unknown
): Promise<T> => {
  const response = await axios.post<T>('', payload, {
    headers: {
      'Content-Type': 'application/json',
    },
  });
  return response.data;
};

export const _delete = async <T = unknown>(payload: unknown): Promise<T> => {
  const response = await axios.delete<T>('', {
    data: payload,
    headers: {
      'Content-Type': 'application/json',
    },
  });
  return response.data;
};

export const _get = async <T = unknown>(params: {
  route?: string;
}): Promise<T> => {
  const response = await axios.get<T>(params.route || '', {
    headers: {
      'Content-Type': 'application/json',
    },
  });
  return response.data;
};

export const _put = async <T = unknown>(data: unknown): Promise<T> => {
  const response = await axios.put<T>('', data, {
    headers: {
      'Content-Type': 'application/json',
    },
  });
  return response.data;
};

const baseUrlV25 = setUrlPathFromDomainForV25(
  'locahost:4000',
  'https://argos-v25-dev.itmsol.fr',
  'https://argos-v25.itmsol.fr'
);

export const _getArgosV25 = async <T = unknown>(data: {
  route: string;
}): Promise<T> => {
  const response = await axios.get<T>(`${baseUrlV25}/${data.route}`, {
    headers: {
      'Content-Type': 'application/json',
    },
    withCredentials: true,
  });
  return response.data;
};

export const _postArgosV25 = async <T = unknown>(data: {
  route: string;
  payload?: unknown;
}): Promise<T> => {
  const response = await axios.post<T>(
    `${baseUrlV25}/${data.route}`,
    data.payload ? data.payload : undefined,
    {
      headers: {
        'Content-Type': 'application/json',
      },
      withCredentials: true,
    }
  );
  return response.data;
};

export const _putArgosV25 = async <T = unknown>(data: {
  route: string;
  payload?: unknown;
}): Promise<T> => {
  const response = await axios.put<T>(
    `${baseUrlV25}/${data.route}`,
    data.payload ? data.payload : undefined,
    {
      headers: {
        'Content-Type': 'application/json',
      },
      withCredentials: true,
    }
  );
  return response.data;
};

export const _deleteArgosV25 = async <T = unknown>(data: {
  route: string;
  payload?: unknown;
}): Promise<T> => {
  const response = await axios.delete<T>(`${baseUrlV25}/${data.route}`, {
    data: data.payload ? data.payload : undefined,
    headers: {
      'Content-Type': 'application/json',
    },
    withCredentials: true,
  });
  return response.data;
};

// Route temporaire pour accèder aux routes des tâches Argos en POST
export const _postArgosV25TasksDebug = async <T = unknown>(data: {
  route: string;
  payload?: unknown;
}): Promise<T> => {
  const response = await axios.post<T>(
    `http://51.255.170.213:5000/${data.route}`,
    data.payload ? data.payload : undefined,
    {
      headers: {
        'Content-Type': 'application/json',
      },
    }
  );
  return response.data;
};
